import React, { Component } from 'react'
import './Obhodnoilist.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

export default class Obhodnoilist extends Component {
    constructor(props) {
        super(props)
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        this.state = {
            currentDate: date
        }
    }

    OpenReportsPage(reportsPage, reportType) {
        this.props.OpenReportsPage(reportsPage, reportType)
    }
    selectLanguage(language) {
        this.props.selectLanguage(language)
    }

    render() {
        const { ObhodnoiList } = this.props
        return (
            <div className='ObhodnoiList D_main_header' >
                <header>
                    <i className="fas fa-arrow-left" onClick={() => this.OpenReportsPage(0, 0)}></i>
                    <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                            )}

                        </PrintContextConsumer>
                    </ReactToPrint>
                    {this.props.language === 1 ? <h2>Обходной лист</h2> : <h2>Обходной лист</h2>}
                    {/* <div className='Language'>
                        <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                        <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                    </div> */}
                </header>

                <div className="A4" ref={el => (this.componentRef = el)}>
                    <span className='avn_date'>{"AVN " + this.state.currentDate}</span>
                    <h3 style={{ margin: '0 auto 0px', textAlign: 'center' }}>ОБХОДНОЙ ЛИСТ</h3>
                    <h3>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[0][0].vuz}</h3>
                    <div>
                        <h4>Ф.И.О:</h4>
                        <h4 style={{ textAlign: 'start', color: '#000', textTransform: 'uppercase' }}>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[0][0].s_fio}</h4>
                    </div>
                    <div>
                        <h4>Факультет:</h4>
                        <p>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[0][0].faculty}</p>
                    </div>
                    <div>
                        <h4>Направление:</h4>
                        <p>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[0][0].direction}</p>
                    </div>
                    <div style={{ gridTemplateColumns: '120px 0.9fr 150px 1fr' }}>
                        <h4>Группа:</h4>
                        <p>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[0][0].p20}</p>
                        <h4>Форма обучения:</h4>
                        <p>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[0][0].p108}</p>
                    </div>
                    {ObhodnoiList && ObhodnoiList.length && ObhodnoiList[1][0].osnovanie !== "" ?
                        <div>
                            <h4>Основание:</h4>
                            <p>{ObhodnoiList && ObhodnoiList.length && ObhodnoiList[1][0].osnovanie}</p>
                        </div> : null}

                    <table>
                        <thead>
                            <tr>
                                <th>№</th>
                                <th>Структурное подразделение</th>
                                <th>Отметка о задолженности</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ObhodnoiList && ObhodnoiList.length && ObhodnoiList[3].map((item, index) => {
                                return (
                                    <tr key={"dolg" + index}>
                                        <td>{index + 1}</td>
                                        <td>{item.okno_title}</td>
                                        <td style={{ textAlign: 'center' }}>{item.dolg && item.dolg !== null && item.dolg === true ? 'Есть задолжнность' : 'Задолженности нет'}</td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>

                    <p style={{ textAlign: 'start', margin: '18px 0 8px' }}>Дата сдачи обходного листа в отдел кадров «_____» __________________202__ г.</p>
                    <div className='Documents'>
                        <p style={{ fontWeight: '600', fontStyle: 'italic', margin: '3px 20px' }}>Получил(а) (указать вид документа):</p>
                        <p><span></span>  - диплом о высшем образовании; </p>
                        <p><span></span>  - аттестат о среднем общем образовании; </p>
                        <p><span></span>  - диплом о среднем профессиональном образовании;</p>
                        <p><span></span> - академическую справку; </p>
                        <p><span></span>  - результаты ОРТ (копия). </p>
                    </div>
                    <nav>
                        {ObhodnoiList && ObhodnoiList.length && ObhodnoiList[5][0].insert_pole ?
                            <p>{ObhodnoiList[5][0].insert_pole}</p> :
                            <p> Отдел кадров _____________________<span>(Ф.И.О.)</span></p>
                        }
                        <p className='Podpis'>__________________ <span>(Подпись)</span></p>
                        <p>«_____» _______202__ г.</p>
                    </nav>
                    <table>
                        <thead>
                            <tr>
                                <th>Примечание</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ObhodnoiList && ObhodnoiList.length && ObhodnoiList[4].length ? ObhodnoiList[4].map((item, index) => {
                                return (
                                    <tr key={"descr" + index}>
                                        <td style={{ textAlign: 'left' }}>{item.okno_description}</td>
                                    </tr>
                                )
                            }) :
                                <tr><td></td></tr>
                            }

                        </tbody>
                    </table>
                </div>

            </div>
        )
    }
}


